"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PushSubscription = /** @class */ (function () {
    function PushSubscription() {
        this._subscriptionObserverList = [];
    }
    PushSubscription.prototype._processFunctionList = function (array, param) {
        for (var i = 0; i < array.length; i++) {
            array[i](param);
        }
    };
    /**
     * Sets initial Push Subscription properties and adds observer for changes
     */
    PushSubscription.prototype._setPropertiesAndObserver = function () {
        var _this = this;
        /**
         * Receive push Id
         * @param obj
         */
        var getIdCallback = function (obj) {
            _this._id = obj.value;
        };
        window.cordova.exec(getIdCallback, function () { }, "OneSignalPush", "getPushSubscriptionId");
        /**
         * Receive token
         * @param obj
         */
        var getTokenCallback = function (obj) {
            _this._token = obj.value;
        };
        window.cordova.exec(getTokenCallback, function () { }, "OneSignalPush", "getPushSubscriptionToken");
        /**
         * Receive opted-in status
         * @param obj
         */
        var getOptedInCallback = function (obj) {
            _this._optedIn = obj.value;
        };
        window.cordova.exec(getOptedInCallback, function () { }, "OneSignalPush", "getPushSubscriptionOptedIn");
        this.addObserver(function (event) {
            _this._id = event.id;
            _this._token = event.token;
            _this._optedIn = event.optedIn;
        });
    };
    Object.defineProperty(PushSubscription.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PushSubscription.prototype, "token", {
        get: function () {
            return this._token;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PushSubscription.prototype, "optedIn", {
        get: function () {
            return this._optedIn || false;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Add a callback that fires when the OneSignal push subscription state changes.
     * @param  {(event: PushSubscriptionState)=>void} observer
     * @returns void
     */
    PushSubscription.prototype.addObserver = function (observer) {
        var _this = this;
        this._subscriptionObserverList.push(observer);
        var subscriptionCallBackProcessor = function (state) {
            _this._processFunctionList(_this._subscriptionObserverList, state);
        };
        window.cordova.exec(subscriptionCallBackProcessor, function () { }, "OneSignalPush", "addPushSubscriptionObserver", []);
    };
    ;
    /**
     * Remove a push subscription observer that has been previously added.
     * @param  {(event: PushSubscriptionState)=>void} observer
     * @returns void
     */
    PushSubscription.prototype.removeObserver = function (observer) {
        var index = this._subscriptionObserverList.indexOf(observer);
        if (index !== -1) {
            this._subscriptionObserverList.splice(index, 1);
        }
    };
    ;
    /**
     * Call this method to receive push notifications on the device or to resume receiving of push notifications after calling optOut. If needed, this method will prompt the user for push notifications permission.
     * @returns void
     */
    PushSubscription.prototype.optIn = function () {
        window.cordova.exec(function () { }, function () { }, "OneSignalPush", "OptInPushSubscription");
    };
    /**
     * If at any point you want the user to stop receiving push notifications on the current device (regardless of system-level permission status), you can call this method to opt out.
     * @returns void
     */
    PushSubscription.prototype.optOut = function () {
        window.cordova.exec(function () { }, function () { }, "OneSignalPush", "optOutPushSubscription");
    };
    return PushSubscription;
}());
exports.default = PushSubscription;
